import React, { SyntheticEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { authApi } from "../../api";
import { BRAND } from "../../brand";
import "./index.css";

const Login = () => {
  const { t } = useTranslation("login");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();
    setLoading(true);
    setLoginError(false);
    try {
      const { data } = await authApi.login(username, password);
      localStorage.setItem("token", data.token);
      navigate("/forms");
    } catch (error) {
      console.error("Login failed:", error);
      setLoginError(true);
    }
    setLoading(false);
  };

  return (
    <div className="cb-login">
      <div className="cb-login__container">
        <div className="cb-login__header">
          <h1 className="cb-login__logo">{t("title")}</h1>
          <p className="cb-login__subtitle">{t("subtitle")}</p>
        </div>

        <div className="cb-login__card">
          <form className="cb-login__form" onSubmit={handleSubmit}>
            <div className="cb-login__field">
              <label className="cb-login__label" htmlFor="username">
                {t("username_label")}
              </label>
              <input
                type="text"
                id="username"
                name="username"
                className="cb-login__input"
                placeholder={t("username_placeholder") as string}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete="username"
              />
            </div>

            <div className="cb-login__field">
              <label className="cb-login__label" htmlFor="password">
                {t("password_label")}
              </label>
              <input
                type="password"
                id="password"
                name="password"
                className="cb-login__input"
                placeholder={t("password_placeholder") as string}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            <button
              className="cb-login__submit"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? t("submitting") : t("submit")}
            </button>
          </form>

          {loginError && <div className="cb-login__error">{t("error")}</div>}
        </div>

        {BRAND.managerUrl && (
          <div className="cb-login__manager">
            {t("no_account")}{" "}
            <a
              href={BRAND.managerUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="cb-login__manager-link"
            >
              {t("contact_manager")}
            </a>
          </div>
        )}

        <div className="cb-login__manager">
          <Link to="/terms" className="cb-login__manager-link">
            {t("terms")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
